// 明瞭さ判定グラフ(円グラフ)の背景スタイルを算出するユーティリティ

function getPieChartColor(measureWord) {
  switch (measureWord) {
    case 'pa':
      return ['#b32d43', '#f9e0e4']; // pa
    case 'ta':
      return ['#05662d', '#daede1']; // ta
    case 'ka':
      return ['#002850', '#e4e8ec']; // ka
    default:
      return ['#cecece', '#cecece']; // デフォルト
  }
}

function buttom(graphPercent, measureWord) {
  const [mainColor, subColor] = getPieChartColor(measureWord);
  return {
    background:
    `conic-gradient(${mainColor} 0%,
    ${mainColor} ${graphPercent[measureWord]}%,
    ${subColor} ${graphPercent[measureWord]}%,
    ${subColor} 100%)`,
    border: `solid 1px ${subColor}`,
  };
}

function center(graphPercent, measureWord) {
  const [mainColor, subColor] = getPieChartColor(measureWord);
  return {
    color: `${mainColor}`,
    border: `solid 1px ${subColor}`,
  };
}

export { buttom, center, getPieChartColor };
